module.exports = __webpack_public_path__ + "static/img/8.0917a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/8.png
// module id = Klp3
// module chunks = 35